let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9e35r")).then(() => parcelRequire('fsePH'));